import axios from 'axios';
const apiEndPoint = process.env.REACT_APP_API_URL;



const getListCompanies = async () => {
  const response = await axios.get(`${apiEndPoint}/companies?_sort=name:ASC`)
  return response.data;

}

export {getListCompanies};